
function parallaxImage() {
  // Select all target parallax divs
  const targets = document.querySelectorAll(".js-parallax");

  // Create an Intersection Observer
  const observer = new IntersectionObserver((entries) => {
      entries.forEach(entry => {
          if (entry.isIntersecting) {
              // Add pinned class when it enters viewport
              entry.target.classList.add('is-pinned');
          } else {
              // Remove pinned class when it leaves
              entry.target.classList.remove('is-pinned');
          }
      });
  }, { threshold: 0 }); // Trigger when any part of the div is visible

  // Observe all target divs
  targets.forEach(target => observer.observe(target));
}


export default function() {
  parallaxImage();
}
